exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-447152b0] .main-content-holder{height:100%;padding-bottom:0}", ""]);

// exports
